import React from 'react'

const ContactPage = () => {
  return (
    <main className="min-h-screen bg-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <header className="mb-10 sm:mb-14">
          <p className="text-sm font-semibold text-emerald-600 mb-2 uppercase tracking-wide">
            Contact
          </p>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-light text-slate-900 mb-4 leading-tight">
            Get in touch with the Obule team
          </h1>
          <p className="text-base sm:text-lg text-slate-600 leading-relaxed max-w-3xl font-light">
            Whether you&apos;re an attendee, organizer, or partner, we&apos;re here to help. Use
            the contact details below to reach the right team, or start with our Help Center for
            quick answers to common questions.
          </p>
        </header>

        <div className="space-y-8 text-base text-slate-600 leading-relaxed font-light">
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">General inquiries</h2>
            <p>
              For general platform questions, feedback, or partnership ideas, please email our
              support team at <span className="font-medium">support@obule.com</span>. We aim to
              respond to most messages within 1–2 business days.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Organizer support</h2>
            <p>
              If you&apos;re a center or organizer using Obule to manage events and offers, you can
              contact our organizer success team for help with onboarding, payouts, and best
              practices for running successful campaigns.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Report an issue</h2>
            <p>
              If you believe there is an issue with your account, a suspicious event or offer, or a
              potential security problem, please reach out as soon as possible so we can
              investigate. Include as many details as you can (order IDs, event names, screenshots)
              to help us resolve the issue quickly.
            </p>
          </section>
        </div>
      </div>
    </main>
  )
}

export default ContactPage

